export default __webpack_public_path__ + "svgs/sfuchsBlack-4a202aeb.svg";